import React from 'react';
import Utils from './Utils';
import PageWrapper from './PageWrapper';
import styled from 'styled-components';

import { ProfileWrapper, ProfileHeader, FlexGrowBox } from './Components'; 
import { MedalIcon, MaestroBadge, MegaMaestroBadge, InfluencerBadge, XpertBadge, EnthusiastBadge, RookieBadge, ProvisionalBadge, RejectedBadge, Emoji, } from './Components'

const LeaderboardHeader = styled.p`
  font-family: 'Inter';
  font-size: 2.5em;
  font-weight: bold;
  line-height: 100%;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 10px;
`;

const RankContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  margin: 5px;
  background-color: ${(props) => (props.isCurrentUser ? '#e0c166' : 'white')};
`;

const UsrName = styled.div`
  font-weight: bold;
  margin-right: 10px;
  font-size: 1.25em;
  font-weight: bold;
`;

const Rank = styled.div`
  font-weight: bold;
  margin-right: 10px;
  font-size: 1.5em;
  font-weight: bold;
`;

const ColumnAligner = styled.div`
  display: flex;
  flex-direction: row;
`

const Score = styled.div`
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 1.5em;
  font-weight: bold;
`;

const FadedOverlay = styled.div`
  position: relative;
  margin: 25px 0;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(
      0deg
      ${({ bot_grad }) => bot_grad && ', rgba(248,248,248,1) 3%, rgba(248,248,248,0) 40%'}
      ${({ top_grad }) => top_grad && ', rgba(248,248,248,0) 60%, rgba(248,248,248,1) 97%'}
    );
    z-index: 1;
  }
`

const FadedOverlayContent = styled.div`
  position: relative;
`

class LeaderboardScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.leaderboardRowMap = this.leaderboardRowMap.bind(this);
  }

  renderBadge(badgeType) {
    let BadgeComponent;
    let emoji;
    
    if (badgeType === 'MegaMaestro') {
      BadgeComponent = MegaMaestroBadge;
      emoji = '😈';
    } else if (badgeType === 'Maestro') {
      BadgeComponent = MaestroBadge;
      emoji = '😎';
    } else if (badgeType === 'Influencer') {
      BadgeComponent = InfluencerBadge;
      emoji = '🫡';
    } else if (badgeType === 'Xpert') {
      BadgeComponent = XpertBadge;
      emoji = '🧐';
    } else if (badgeType === 'Enthusiast') {
      BadgeComponent = EnthusiastBadge;
      emoji = '🤩';
    } else if (badgeType === 'Rookie') {
      BadgeComponent = RookieBadge;
      emoji = '😀';
    } else if (badgeType === 'Provisional') {
      BadgeComponent = ProvisionalBadge;
      emoji = '😴';
    } else if (badgeType === 'Rejected') {
      BadgeComponent = RejectedBadge;
      emoji = '😥';
    } 

    return (
      <BadgeComponent>
        <Emoji>{emoji}</Emoji> {badgeType}
      </BadgeComponent>
    );
  }

  leaderboardRowMap(item) {
    return (
      <RankContainer isCurrentUser={Boolean(item['is_curr_user'])} key={`rank_${item['username']}`}>
        <ColumnAligner style={{'width': '10%'}}><Rank>{MedalIcon(item['disp_rank'])} {item['disp_rank']}. {item['tied'] ? <a style={{ fontSize: "0.75em" }}>(T)</a> : ""}</Rank></ColumnAligner>
        <ColumnAligner style={{'width': '45%'}}><UsrName>{item['username']}</UsrName></ColumnAligner>
        <ColumnAligner style={{'width': '20%'}}>{this.renderBadge(item['curr_tier'])}</ColumnAligner>
        <ColumnAligner style={{'width': '25%'}}><Score>{item['score']} Pts.</Score></ColumnAligner>
        {/* <ColumnAligner style={{'width': '10%'}}>
          {Boolean(item['is_curr_user']) && <Score> 🏆 </Score>}
        </ColumnAligner> */}
      </RankContainer>
    )
  }

  renderRankings(source, leaderboardProps) {
    leaderboardProps = JSON.parse(leaderboardProps.replaceAll("&#34;", "\""));
    if (!leaderboardProps.two_segment) {    
      return (
        <FlexGrowBox style={{'width': '750px'}} key={source}>
          <LeaderboardHeader>{source} Performance Leaderboard</LeaderboardHeader>
          <FadedOverlay top_grad={false} bot_grad={leaderboardProps.bot_grad}>
            <FadedOverlayContent>
              {leaderboardProps.rankings.map(this.leaderboardRowMap)}
            </FadedOverlayContent>
          </FadedOverlay>
        </FlexGrowBox>
      )
    }
    return (
      <FlexGrowBox style={{'width': '750px'}} key={source}>
        <LeaderboardHeader>{source} Performance Leaderboard</LeaderboardHeader>
        <FadedOverlay top_grad={false} bot_grad={true}>
          <FadedOverlayContent>
            {leaderboardProps.rankings.slice(0, leaderboardProps.split_pt).map(this.leaderboardRowMap)}
          </FadedOverlayContent>
        </FadedOverlay>
        <br/>
        <FadedOverlay top_grad={true} bot_grad={leaderboardProps.bot_grad}>
          <FadedOverlayContent>
            {leaderboardProps.rankings.slice(leaderboardProps.split_pt).map(this.leaderboardRowMap)}
          </FadedOverlayContent>
        </FadedOverlay>
      </FlexGrowBox>
    )
  }

  renderLeaderboards() {
    if (this.props.source === 'actor') {
      return this.renderRankings('Actor', this.props.actor_leaderboard)
    } else if (this.props.source === 'slack') {
      return this.renderRankings('Slack', this.props.slack_leaderboard)
    } else {
      return ([
          this.renderRankings('Actor', this.props.actor_leaderboard),
          this.renderRankings('Slack', this.props.slack_leaderboard)])
    }
  }

  render() {
    return (
      <PageWrapper isAdmin={this.props.isAdmin} >
        <ProfileWrapper>{this.renderLeaderboards()}</ProfileWrapper>
        <div style={{ textAlign: "center" }}>
          <h2>What Does My Score Mean?</h2>
          <p>Your score is calculated by multiplying your number of accepted work by your task acceptance rate, both displayed on your profile. To boost your score (and climb higher on the leaderboards), focus on completing more tasks and improving your task acceptance rate, but raising your acceptance rate will have a greater impact!</p>
        </div>
      </PageWrapper>
    );
  }
}

export default LeaderboardScreen;